module.exports = __webpack_public_path__ + "static/media/gdpr.9b35ecbd.png";